module.exports = __webpack_public_path__ + "static/media/FreshGrocer-DD-HERO.ea4d9533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FreshGrocer-DD-HERO.jpg
// module id = 355
// module chunks = 0